import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import AgentInvoiceList from "../../components/agentInvoice";
import { AgentService } from "../../services";

class AgentInvoice extends Component {
  constructor(props) {
    super(props);
    this.agentService = new AgentService();
  }

  state = {
   // createUserModal: false,
    data: [],
    canNotAddMoreUser: true
  };

  componentDidMount() {
    this.getUsers();
    
    //this.getAgentList();
  }

  // toggle = () => {
  //   this.setState(prevState => ({
  //     createUserModal: !prevState.createUserModal
  //   }));
  // };

  getUsers = async () => {
    try {
      let { data } = await this.agentService.getAgentList();
      console.log("Get Agent list Data 4",data);
      this.setState({ data:data["response"][0], canNotAddMoreUser: (data["response"][0]).length > 2  });
     
    } catch (error) {
      this.setState({ data: [] });
    }
  };

  render() {
    return (
      <div>
        <Breadcrumb style={{ marginTop: "1%" }}>
          <BreadcrumbItem>
            <Link to="/dashboard">Dashbarod</Link>
          </BreadcrumbItem>

          <BreadcrumbItem active>Agent Invoice</BreadcrumbItem>
        </Breadcrumb>

        
        {/* <div>
          <Card className={"rectangle-border"}>
            <CardBody className={"d-flex justify-content-end"}>
              <Button
                onClick={this.toggle}
                color="primary"
                className={"rectangle-border "}
               // disabled={this.state.canNotAddMoreUser}
              >
                <i className="fas fa-user"></i>create nvoice
              </Button>
            </CardBody>
          </Card>
        </div> */}
        <div className="mt-3">
          <AgentInvoiceList data={this.state.data}  getUsers={this.getUsers}/>
        </div>

        {/* create user form
        <CreateAgentInvoiceForm
          modal={this.state.createUserModal}
          toggle={this.toggle}
          fetchUses={this.getUsers}
        /> */}
      </div>
    );
  }
}

export default AgentInvoice;
